import { useEffect, useState } from 'react';

/**
 * 키보드 상태 통합 hook (WebView 환경 기준).
 *
 * - visualViewport.resize로 키보드 높이 추적
 * - react-native-webview에서 (innerHeight - vv.height)가 키보드+광고+nav 합으로 잡히는
 *   케이스가 있어 viewport 50%로 clamp (키보드는 보통 화면 30~40% 수준)
 *
 * @returns {{ keyboardHeight: number, keyboardOpen: boolean, viewportHeight: number }}
 */
export default function useKeyboard() {
    const [viewportHeight, setViewportHeight] = useState(
        () => window.visualViewport?.height || window.innerHeight
    );
    const [keyboardHeight, setKeyboardHeight] = useState(0);

    useEffect(() => {
        const vv = window.visualViewport;
        const handleResize = () => {
            const visualBottom = vv ? vv.height + vv.offsetTop : window.innerHeight;
            setViewportHeight(visualBottom);
            const raw = Math.max(0, window.innerHeight - visualBottom);
            const offset = Math.max(0, Math.min(raw, window.innerHeight * 0.5));
            setKeyboardHeight(offset);
        };
        vv?.addEventListener('resize', handleResize);
        vv?.addEventListener('scroll', handleResize);
        handleResize();
        return () => {
            vv?.removeEventListener('resize', handleResize);
            vv?.removeEventListener('scroll', handleResize);
        };
    }, []);

    return {
        keyboardHeight,
        keyboardOpen: keyboardHeight > 100,
        viewportHeight,
    };
}
